
import { Base } from '../base-component';

import './product-card.component.scss';

import * as $ from 'jquery';

export class ProductCard extends Base {


	constructor(element: Element){
		
		super(element);
				
	}
		
	init(){

	}
		
	bindEvents() {
	
	}

}


// WEBPACK FOOTER //
// ./components/product-card/product-card.component.ts